import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppStateService } from '../../core/services/app-state.service';
import { SearchPanelComponent } from '../../shared/components/search-panel/search-panel.component';

@Component({
  selector: 'pec-topbar',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, SearchPanelComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  readonly state = inject(AppStateService);

  get showAiBadge(): boolean {
    return this.state.screen() === 'list' && this.state.view() === 'inbox';
  }
}
